import { Trophy, RotateCcw } from "lucide-react";
import { Avatar } from "../ui";
import { POINTS } from "../game";

export default function Scoreboard({ board, delta, onReset }) {
  const rows = Object.entries(board.scores).sort((a, b) => b[1] - a[1]);
  const top = rows.length ? rows[0][1] : 0;
  return (
    <section className="glass section scoreboard" data-testid="scoreboard">
      <div className="section-head">
        <h2><Trophy size={16} className="accent" /> Marcador de la noche</h2>
        <span className="badge" data-testid="scoreboard-games">{board.games} {board.games === 1 ? "partida" : "partidas"}</span>
      </div>
      <ol className="score-list">
        {rows.map(([name, pts], i) => (
          <li key={name} className={pts === top && pts > 0 ? "leader" : ""} data-testid={`score-row-${i}`}>
            <span className="turn-num">{i + 1}</span>
            <Avatar name={name} size="sm" />
            <span className="grow">{name}</span>
            {delta && delta[name] > 0 && <span className="score-delta" data-testid={`score-delta-${i}`}>+{delta[name]}</span>}
            <strong className="score-pts" data-testid={`score-points-${i}`}>{pts}</strong>
          </li>
        ))}
      </ol>
      <p className="muted small">Inocente ganador +{POINTS.inocente} · Impostor ganador +{POINTS.impostor}. Se reinicia solo tras 12 h.</p>
      {onReset && (
        <button className="btn btn-ghost full" onClick={onReset} data-testid="reset-scoreboard-btn"><RotateCcw size={18} /> Reiniciar marcador</button>
      )}
    </section>
  );
}
